import { createReducer } from '@reduxjs/toolkit';
import {
  CLEAR_SOFTWARES,
  CREATE_SOFTWARE,
  DELETE_SOFTWARE,
  GET_SOFTWARES,
  GET_SOFTWARE_PRODUCT_CODES,
  GET_SOFTWARE_TARGET_HARDWARES,
} from '../actions/softwares';

type Paginaged<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    per_page: number;
  };
};

type Software = unknown;

export type SoftwareState = {
  softwares: Paginaged<Software>;
  softwareProductCodes: string[];
  softwareTargetHardwares: string[];
};

const initState: SoftwareState = {
  softwares: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareProductCodes: [],
  softwareTargetHardwares: [],
};

const softwareReducer = createReducer(initState, (builder) =>
  builder
    .addCase(CLEAR_SOFTWARES, (state) => {
      return { ...state, softwares: initState.softwares };
    })
    .addCase(GET_SOFTWARES, (state, action) => {
      return { ...state, softwares: action.payload };
    })
    .addCase(GET_SOFTWARE_PRODUCT_CODES, (state, action) => {
      return { ...state, softwareProductCodes: action.payload };
    })
    .addCase(GET_SOFTWARE_TARGET_HARDWARES, (state, action) => {
      return { ...state, softwareTargetHardwares: action.payload };
    })
    .addCase(CREATE_SOFTWARE, (state) => state)
    .addCase(DELETE_SOFTWARE, (state) => state)
);

export default softwareReducer;
